import { render } from "./Hero.vue?vue&type=template&id=2ed2199b&scoped=true&ts=true"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=2ed2199b&lang=stylus"
import "./Hero.vue?vue&type=style&index=1&id=2ed2199b&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed2199b"]])

export default __exports__